import { __decorate, __metadata } from "tslib";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { setInteractionMode } from "vee-validate";
import { Guid } from "guid-typescript";
import ClientDetailsMixin from "../ClientDetailsMixin";
import StrictDateMixin from "@/router/views/StrictDateMixin";
import ClientModule from "@/store/modules/client.module";
import { ClientOpportunityModel } from "@/store/models/client/clientOpportunity";
import DeleteComponent from "@/components/deleteComponent.vue";
import Loader from "@/components/widgets/loader.vue";
import { toaster } from "@/utilities/toaster";
import { RECHECK_MODE } from "@/types/validators";
const OPPORTUNITY_DATE_BEFORE_START = "Opportunity Date should be the same as or later than the client's Start Date.";
setInteractionMode("passive");
/**
 * Client Details — Opportunities tab. Opportunity timeline with its Add/Edit
 * modals and delete confirmation (driven by the opportunityInfo region).
 */
let ClientOpportunitiesTabComponent = /** @class */ (() => {
    var _a;
    let ClientOpportunitiesTabComponent = class ClientOpportunitiesTabComponent extends Mixins(ClientDetailsMixin, StrictDateMixin) {
        constructor() {
            super(...arguments);
            this.recheckMode = RECHECK_MODE;
            this.clientOpportunity = new ClientOpportunityModel();
            this.editOpportunityDTO = new ClientOpportunityModel();
            this.showDeleteOpportunityModal = false;
            // Opportunities whose author photo failed to load - they fall back to initials
            this.brokenAuthorImageIds = [];
        }
        showAuthorImage(opportunity) {
            return !!opportunity.createdByImageURL && this.brokenAuthorImageIds.indexOf(String(opportunity.id)) === -1;
        }
        onAuthorImageError(opportunity) {
            this.brokenAuthorImageIds = [...this.brokenAuthorImageIds, String(opportunity.id)];
        }
        // Each modal is open only while the machine is in its state.
        onStateChange(state) {
            this.toggleModal("add-opportunity", state.matches("loadedClientContactsInfo.opportunityInfo.addOpportunityInfo"));
            this.toggleModal("edit-opportunity", state.matches("loadedClientContactsInfo.opportunityInfo.updateOpportunityInfo"));
        }
        toggleModal(id, visible) {
            if (visible) {
                this.$bvModal.show(id);
            }
            else {
                this.$bvModal.hide(id);
            }
        }
        addOpportunity() {
            ClientModule.GetClientAssignedEmployees(this.clientId);
            this.clientOpportunity = new ClientOpportunityModel();
            this.clearDateErrors();
            this.machineService.send({ type: "ADD_OPPORTUNITY" });
        }
        // Opportunity dates: nothing before the client's Start Date
        disableBeforeClientStart(date) {
            return this.isBeforeClientStartDate(date, this.client ? this.client.startDate : null);
        }
        saveClientOpportunity() {
            this.validate("newOpportunityObserver").then((res) => {
                if (res && !this.hasDateErrors) {
                    if (this.disableBeforeClientStart(this.clientOpportunity.opportunityDate)) {
                        toaster.ShowError(OPPORTUNITY_DATE_BEFORE_START);
                        return;
                    }
                    this.clientOpportunity.clientId = this.clientId.toString();
                    this.clientOpportunity.opportunityDateAsString = this.formatClientDate(this.clientOpportunity.opportunityDate);
                    this.machineService.send({
                        type: "ADDING_OPPORTUNITY",
                        payLoad: this.clientOpportunity,
                    });
                }
            });
        }
        editOpportunity(opportunity) {
            ClientModule.GetClientAssignedEmployees(this.clientId);
            // The listing returns opportunityDate as an ISO string; the date-picker only renders Date values.
            this.editOpportunityDTO = Object.assign({}, opportunity, { opportunityDate: opportunity.opportunityDate ? new Date(opportunity.opportunityDate) : null });
            this.clearDateErrors();
            this.machineService.send({ type: "UPDATE_OPPORTUNITY" });
        }
        updateClientOpportunity() {
            this.validate("editOpportunityObserver").then((res) => {
                if (res && !this.hasDateErrors) {
                    // Also catches an older opportunity whose date predates a Start Date set later
                    if (this.disableBeforeClientStart(this.editOpportunityDTO.opportunityDate)) {
                        toaster.ShowError(OPPORTUNITY_DATE_BEFORE_START);
                        return;
                    }
                    this.editOpportunityDTO.opportunityDateAsString = this.formatClientDate(this.editOpportunityDTO.opportunityDate);
                    this.machineService.send({
                        type: "UPDATING_OPPORTUNITY",
                        payLoad: this.editOpportunityDTO,
                    });
                }
            });
        }
        cancelOpportunity() {
            this.machineService.send({ type: "CLOSE_MODAL" });
        }
        openDeleteOpportunityModal(opportunityId) {
            this.delOpportunityValueId = opportunityId;
            this.showDeleteOpportunityModal = true;
            this.machineService.send({ type: "DELETE_OPPORTUNITY" });
        }
        deleteOpportunity() {
            this.machineService.send({
                type: "DELETING_OPPORTUNITY",
                payLoad: this.delOpportunityValueId,
            });
            this.showDeleteOpportunityModal = false;
        }
        cancelDelete() {
            this.showDeleteOpportunityModal = false;
            this.machineService.send({ type: "CLOSE_MODAL" });
        }
        // Computed
        get clientOpportunities() {
            return ClientModule.clientOpportunities;
        }
        get clientAssignedEmployees() {
            return ClientModule.clientAssignedEmployees;
        }
        get isOpportunityLoading() {
            return ["gettingClientOpportunitiesInfo", "addingOpportunityInfo", "updatingOpportunityInfo", "deletingOpportunityInfo"].some((s) => this.state.matches(`loadedClientContactsInfo.opportunityInfo.${s}`));
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], ClientOpportunitiesTabComponent.prototype, "client", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof Guid !== "undefined" && Guid) === "function" ? _a : Object)
    ], ClientOpportunitiesTabComponent.prototype, "clientId", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], ClientOpportunitiesTabComponent.prototype, "state", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], ClientOpportunitiesTabComponent.prototype, "machineService", void 0);
    __decorate([
        Watch("state"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ClientOpportunitiesTabComponent.prototype, "onStateChange", null);
    ClientOpportunitiesTabComponent = __decorate([
        Component({
            name: "ClientOpportunitiesTabComponent",
            components: {
                Loader,
                DeleteComponent,
            },
        })
    ], ClientOpportunitiesTabComponent);
    return ClientOpportunitiesTabComponent;
})();
export default ClientOpportunitiesTabComponent;
